import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useRef, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { useKeyboardFocusState } from '../../utils/useKeyboardFocusState';
import { Icon } from '../Icon/index';
import { disabledOpacity, fontSizes, ICON_SPACING, ICON_HOVER_GAP, ICON_BORDER_WIDTH, ICON_SELECTED_BORDER_WIDTH, } from './constants';
import { IconPickerContext } from './IconPickerContext';
const iconSizes = {
    large: 'medium',
    medium: 'small',
    small: 'extraSmall',
};
const sizePaddings = {
    large: theme.spacing.x2,
    medium: theme.spacing.base,
    small: theme.spacing.base,
};
const defaultProps = {
    className: '',
    disabled: false,
    name: '',
};
const IconPickerIconChild = ({ ariaDescribedBy, ariaLabel, ariaLabelledBy, className = defaultProps.className, disabled = defaultProps.disabled, iconType, id, lastChild, name = defaultProps.name, value, }) => {
    const inputRef = useRef(null);
    const isKeyboardFocused = useKeyboardFocusState(inputRef);
    return (_jsx(IconPickerContext.Consumer, { children: ({ border, onChange, pickerName, selectedValue, size = 'medium', }) => {
            const selected = value === selectedValue;
            const iconContainerStyles = disabled && css `
            opacity: ${disabledOpacity};
          `;
            const iconStyles = css `
            ${styleUtils.borderBox}
            ${styleUtils.flexCenter}
            border-color: ${border ? theme.colors.gray400 : 'transparent'};
            border-style: solid;
            border-width: ${styleUtils.rem(ICON_BORDER_WIDTH)};
            margin-right: ${lastChild ? 0 : ICON_SPACING[size]};
            padding: ${sizePaddings[size]};

            &::after {
              content: '';
              box-sizing: border-box;
              display: block;
              position: absolute;
              width: ${styleUtils.rem(fontSizes[size] + 2 * (ICON_HOVER_GAP + ICON_BORDER_WIDTH + ICON_SELECTED_BORDER_WIDTH))};
            height: ${styleUtils.rem(fontSizes[size] + 2 * (ICON_HOVER_GAP + ICON_BORDER_WIDTH + ICON_SELECTED_BORDER_WIDTH))};
            border-style: solid;
            border-width: ${styleUtils.rem(ICON_SELECTED_BORDER_WIDTH)};
            border-color: ${selected ? theme.colors.gray700 : 'transparent'};
            z-index: 0;
          }

          &:hover::after {
            border-color: ${selected ? theme.colors.gray700 : theme.colors.gray400};
          }

          ${isKeyboardFocused && css `
            ${styleUtils.focusVisibleStyles};
          `}
        `;
            return (_jsxs("label", Object.assign({ className: className, css: iconStyles, htmlFor: id, title: name }, { children: [_jsx("span", Object.assign({ "aria-hidden": "true", css: iconContainerStyles }, { children: _jsx(Icon, { size: iconSizes[size], type: iconType }) })), _jsx("input", { "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : name, "aria-labelledby": ariaLabelledBy, css: styleUtils.visuallyHidden, defaultChecked: selected, disabled: disabled, id: id, name: pickerName, onChange: onChange, ref: inputRef, type: "radio", value: value })] })));
        } }));
};
const MemoizedIconPickerIconChild = memo(IconPickerIconChild);
export { MemoizedIconPickerIconChild as IconPickerIconChild };
// MC-1068 Temporary hack for Storybook.
export default IconPickerIconChild;
